<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Tiskalnika M3250, MS622">
     Tiskalnika M3250, MS622
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sl" title="Varnostne informacije">
     Varnostne informacije
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvencije">
      Konvencije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Izjave o izdelku">
      Izjave o izdelku
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_sl" title="Seznanite se s tiskalnikom">
     Seznanite se s tiskalnikom
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sl" title="Iskanje informacij o tiskalniku">
      Iskanje informacij o tiskalniku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_sl" title="Izbiranje mesta za tiskalnik">
      Izbiranje mesta za tiskalnik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sl" title="Konfiguracije tiskalnika">
      Konfiguracije tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_sl" title="Priključitev kablov">
      Priključitev kablov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sl" title="Uporaba nadzorne plo&scaron;če">
      Uporaba nadzorne plo&scaron;če
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_sl" title="Razumevanje stanja gumba za vklop/izklop in indikatorske lučke">
      Razumevanje stanja gumba za vklop/izklop in indikatorske lučke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_sl" title="Tiskanje strani z omrežnimi nastavitvami">
      Tiskanje strani z omrežnimi nastavitvami
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sl" title="Nastavitev in uporaba programov na začetnem zaslonu">
     Nastavitev in uporaba programov na začetnem zaslonu
    </a>
   </p>
   <div id="divd0e746">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_sl" title="Uporaba začetnega zaslona">
      Uporaba začetnega zaslona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_sl" title="Prilagajanje začetnega zaslona">
      Prilagajanje začetnega zaslona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_sl" title="Uporaba prilagoditve zaslona">
      Uporaba prilagoditve zaslona
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_sl" title="Konfiguriranje nastavitev varčevanja">
      Konfiguriranje nastavitev varčevanja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_sl" title="Uporaba podpore za stranke">
      Uporaba podpore za stranke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_sl" title="Uporaba generatorja kod QR">
      Uporaba generatorja kod QR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_sl" title="Nastavitev kvot za napravo">
      Nastavitev kvot za napravo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_sl" title="Ustvarjanje profila na platformi Cloud Connector">
      Ustvarjanje profila na platformi Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1092" title="Upravljanje zaznamkov">
      Upravljanje zaznamkov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1169" title="Upravljanje stikov">
      Upravljanje stikov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_sl" title="Nastavitev in uporaba pripomočkov za osebe s posebnimi potrebami">
     Nastavitev in uporaba pripomočkov za osebe s posebnimi potrebami
    </a>
   </p>
   <div id="divd0e1288">
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_sl" title="Vklop glasovnega vodenja">
      Vklop glasovnega vodenja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_sl" title="Krmarjenje po zaslonu s potezami">
      Krmarjenje po zaslonu s potezami
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_sl" title="Omogočanje načina povečave">
      Omogočanje načina povečave
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_sl" title="Prilagajanje hitrosti govora pri glasovnem vodenju">
      Prilagajanje hitrosti govora pri glasovnem vodenju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_sl" title="Uporaba tipkovnice na zaslonu">
      Uporaba tipkovnice na zaslonu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_sl" title="Omogočanje izgovarjanja gesel ali osebnih identifikacijskih &scaron;tevilk">
      Omogočanje izgovarjanja gesel ali osebnih identifikacijskih &scaron;tevilk
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_sl" title="Nalaganje papirja in posebnih tiskalnih medijev">
     Nalaganje papirja in posebnih tiskalnih medijev
    </a>
   </p>
   <div id="divd0e1493">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_sl" title="Nastavitev velikosti in vrste papirja">
      Nastavitev velikosti in vrste papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_sl" title="Konfiguracija univerzalnih nastavitev papirja">
      Konfiguracija univerzalnih nastavitev papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_sl" title="Nalaganje na pladnje">
      Nalaganje na pladnje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_sl" title="Nalaganje v večnamenski podajalnik">
      Nalaganje v večnamenski podajalnik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_sl" title="Povezovanje pladnjev">
      Povezovanje pladnjev
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_sl" title="Držalo za papir">
     Držalo za papir
    </a>
   </p>
   <div id="divd0e1660">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_sl" title="Podprte velikosti papirja">
      Podprte velikosti papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_sl" title="Podprte vrste papirja">
      Podprte vrste papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_sl" title="Podprte teže papirja">
      Podprte teže papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_sl" title="Neustrezen papir">
      Neustrezen papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_sl" title="Uporaba recikliranega papirja">
      Uporaba recikliranega papirja
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_sl" title="Tiskanje">
     Tiskanje
    </a>
   </p>
   <div id="divd0e2519">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_sl" title="Tiskanje iz računalnika">
      Tiskanje iz računalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2545" title="Tiskanje iz mobilne naprave">
      Tiskanje iz mobilne naprave
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_sl" title="Tiskanje s pogona Flash">
      Tiskanje s pogona Flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_sl" title="Podprti bliskovni pogoni in vrste datotek">
      Podprti bliskovni pogoni in vrste datotek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sl" title="Konfiguracija zaupnih opravil">
      Konfiguracija zaupnih opravil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sl" title="Tiskanje zaupnih in drugih zadržanih opravil">
      Tiskanje zaupnih in drugih zadržanih opravil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_sl" title="Tiskanje iz profila na platformi Cloud Connector">
      Tiskanje iz profila na platformi Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_sl" title="Tiskanje seznama vzorcev pisav">
      Tiskanje seznama vzorcev pisav
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_sl" title="Tiskanje seznama imenikov">
      Tiskanje seznama imenikov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sl" title="Preklic opravila tiskanja">
      Preklic opravila tiskanja
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sl" title="Razumevanje menijev tiskalnika">
     Razumevanje menijev tiskalnika
    </a>
   </p>
   <div id="divd0e3055">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_sl" title="Zemljevid menijev">
      Zemljevid menijev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3374" title="Naprava">
      Naprava
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e5220" title="Natisni">
      Natisni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e6478" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e6740" title="Pogon USB">
      Pogon USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6961" title="Omrežje/vrata">
      Omrežje/vrata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8751" title="Varnost">
      Varnost
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e9886" title="Poročila">
      Poročila
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_sl" title="Pomoč">
      Pomoč
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e10134" title="Odpravljanje težav">
      Odpravljanje težav
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_sl" title="Tiskanje strani z nastavitvami menija">
      Tiskanje strani z nastavitvami menija
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_sl" title="Za&scaron;čita tiskalnika">
     Za&scaron;čita tiskalnika
    </a>
   </p>
   <div id="divd0e10186">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_sl" title="Iskanje varnostne reže">
      Iskanje varnostne reže
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sl" title="Brisanje pomnilnika tiskalnika">
      Brisanje pomnilnika tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_sl" title="Brisanje pomnilnika trdega diska tiskalnika">
      Brisanje pomnilnika trdega diska tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_sl" title="&Scaron;ifriranje trdega diska tiskalnika">
      &Scaron;ifriranje trdega diska tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sl" title="Obnovitev privzetih tovarni&scaron;kih nastavitev">
      Obnovitev privzetih tovarni&scaron;kih nastavitev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_sl" title="Izjava o obstojnosti">
      Izjava o obstojnosti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sl" title="Vzdrževanje tiskalnika">
     Vzdrževanje tiskalnika
    </a>
   </p>
   <div id="divd0e10400">
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_sl" title="Nastavitev e-po&scaron;tnih opozoril">
      Nastavitev e-po&scaron;tnih opozoril
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_sl" title="Prilagajanje privzete glasnosti slu&scaron;alk">
      Prilagajanje privzete glasnosti slu&scaron;alk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10462" title="Omrežje">
      Omrežje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_sl" title="Nastavitev zaporednega tiskanja (samo za Windows)">
      Nastavitev zaporednega tiskanja (samo za Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_sl" title="Či&scaron;čenje tiskalnika">
      Či&scaron;čenje tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_sl" title="Naročanje delov in potro&scaron;nega materiala">
      Naročanje delov in potro&scaron;nega materiala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e11198" title="Zamenjava delov in potro&scaron;nega materiala">
      Zamenjava delov in potro&scaron;nega materiala
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e11342" title="Premikanje tiskalnika">
      Premikanje tiskalnika
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e11398" title="Varčevanje z energijo in papirjem">
      Varčevanje z energijo in papirjem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e11502" title="Recikliranje">
      Recikliranje
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_sl" title="Odpravljanje zastojev">
     Odpravljanje zastojev
    </a>
   </p>
   <div id="divd0e11535">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_sl" title="Preprečevanje zastojev">
      Preprečevanje zastojev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_sl" title="Prepoznavanje mest zastojev">
      Prepoznavanje mest zastojev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_sl" title="Zastoj papirja v vratcih A">
      Zastoj papirja v vratcih A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_sl" title="Zastoj papirja v zadnjih vratcih">
      Zastoj papirja v zadnjih vratcih
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_sl" title="Zastoj papirja v standardnem predalu">
      Zastoj papirja v standardnem predalu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_sl" title="Zagozden papir v enoti za obojestransko tiskanje">
      Zagozden papir v enoti za obojestransko tiskanje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_sl" title="Zastoj papirja na pladnjih">
      Zastoj papirja na pladnjih
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_sl" title="Zastoj papirja v večnamenskem podajalniku">
      Zastoj papirja v večnamenskem podajalniku
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sl" title="Odpravljanje težav">
     Odpravljanje težav
    </a>
   </p>
   <div id="divd0e11811">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11814" title="Težave z omrežno povezavo">
      Težave z omrežno povezavo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12128" title="Težave s strojno opremo">
      Težave s strojno opremo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12402" title="Težave s potro&scaron;nim materialom">
      Težave s potro&scaron;nim materialom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_sl" title="Težave pri podajanju papirja">
      Težave pri podajanju papirja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_sl" title="Težave pri tiskanju">
      Težave pri tiskanju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sl" title="Vzpostavitev stika s podporo strankam">
      Vzpostavitev stika s podporo strankam
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_sl" title="Nadgradnja in selitev">
     Nadgradnja in selitev
    </a>
   </p>
   <div id="divd0e15394">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e15397" title="Strojna oprema">
      Strojna oprema
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e15707" title="Programska oprema">
      Programska oprema
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15790" title="Vdelana programska oprema">
      Vdelana programska oprema
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sl" title="Obvestila">
     Obvestila
    </a>
   </p>
   <div id="divd0e15876">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15879" title="Informacije o izdelku">
      Informacije o izdelku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15896" title="Obvestilo o izdaji">
      Obvestilo o izdaji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sl" title="Blagovne znamke">
      Blagovne znamke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sl" title="Obvestila o licenciranju">
      Obvestila o licenciranju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sl" title="Zvočne emisije">
      Zvočne emisije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_sl" title="Direktiva o odpadni električni in elektronski opremi (OEEO)">
      Direktiva o odpadni električni in elektronski opremi (OEEO)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16000" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sl" title="Odlaganje izdelka">
      Odlaganje izdelka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16034" title="Litij-ionska baterija za polnjenje">
      Litij-ionska baterija za polnjenje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sl" title="Uredba (EU) 2023/1542">
      Uredba (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sl" title="Vračanje Lexmarkovih kartu&scaron; za ponovno uporabo ali recikliranje">
      Vračanje Lexmarkovih kartu&scaron; za ponovno uporabo ali recikliranje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sl" title="Obvestilo o občutljivosti na statično elektriko">
      Obvestilo o občutljivosti na statično elektriko
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sl" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sl" title="Informacije o temperaturi">
      Informacije o temperaturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sl" title="Obvestilo o laserskem tiskalniku">
      Obvestilo o laserskem tiskalniku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sl" title="Poraba energije">
      Poraba energije
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16274" title="Regulativna obvestila za brezžične izdelke">
      Regulativna obvestila za brezžične izdelke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sl" title="Obvestilo o modularnih komponentah">
      Obvestilo o modularnih komponentah
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sl" title="Izpostavljenost radiofrekvenčnemu sevanju">
      Izpostavljenost radiofrekvenčnemu sevanju
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16300" title="Skladnost z direktivami Evropske skupnosti (ES)">
      Skladnost z direktivami Evropske skupnosti (ES)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_sl" title="Skladnost z direktivami Evropske skupnosti (ES)">
      Skladnost z direktivami Evropske skupnosti (ES)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_sl" title="Obvestilo o radijskih motnjah">
      Obvestilo o radijskih motnjah
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue